import { PatientExternalIdentifierIndexesResponse } from "@/Common/Api/Patient/Dto/PatientExternalIdentifierIndexes/PatientExternalIdentifierIndexesResponse";
import { PatientExternalIdentifierResponse as PatientExternalIdentifierResponse } from "@/Common/Api/Patient/Dto/PatientExternalIdentifierIndexes/PatientExternalIdentifierResponse";
import { Patient } from "@/Common/Models/Patient/Patient";
import { ClientIdentifier } from "@/Common/Utilities/ClientIdentifier";

class PatientExternalIdentifier {
    public IsVisible: boolean = false;
    public ResponseModel: PatientExternalIdentifierResponse;
    public IndexConfig: PatientExternalIdentifierIndexesResponse;
    public RelatedSites: string[];

    public get Number(): string { return this.ResponseModel.Number; }
    public get SystemCode(): string { return this.ResponseModel.SystemCode; }
    public get IndexCode(): string { return this.ResponseModel.IndexCode; }
    public get ShortName(): string { return this.IndexConfig?.Acronym ?? this.SystemCode; }

    constructor(responseModel: PatientExternalIdentifierResponse) {
        this.ResponseModel = responseModel;

        this.IndexConfig = cacheStore.PatientExternalIdentifierIndexesBySystemCode[this.SystemCode]
            ?.firstOrDefault(p => p.IndexCode == this.IndexCode);

        this.RelatedSites = cacheStore.PatientExternalIdentifierIndexesSitesBySystemCode[this.SystemCode]
            ?.filter(p => p.IndexCode == this.IndexCode)
            ?.map(p => p.SiteId) ?? [];

        this.IsVisible = this.IndexConfig?.IsVisible ?? false;
    }

    public static GetExternalSearchDefaultSearchForActiveSite(patientModel: Patient): string {
        return PatientExternalIdentifier.GetExternalSearchDefaultSearchForSiteId(patientModel, sessionStore.getCurrentEmployee().getActiveSite()?.Model.Id);
    }

    public static GetExternalSearchDefaultSearchForSiteId(patientModel: Patient, sideId: string): string {
        let identifier = "";
        if (patientModel.ExternalIdentifiers?.any()) {
            const defaultSearchSystemId = cacheStore.ExternalSearchSystemSitesResponse?.firstOrDefault(p => p.SiteId == sideId)?.Id;
            const defaultSearchSystemCode = cacheStore.ExternalSearchSystemsResponse.firstOrDefault(p => p.Id == defaultSearchSystemId).Code;

            let systemIdentifiers = patientModel.ExternalIdentifiers.filter(p => p.SystemCode == defaultSearchSystemCode);

            // search prefers filling the search box with with identifier that are visible to the user (They search with what they know/see)
            identifier = systemIdentifiers.firstPreferredOrDefault(p => p.IndexConfig?.IsVisible)?.Number ?? "";
        }

        if (IsNullOrWhiteSpace(identifier)) {
            // Legacy interfaces support.
            // Use Identifier01
            identifier = patientModel.IndividualResponse.NAM || patientModel.PatientResponse.ChartNumber; // Use NAM by default
            if (ClientIdentifier.IsHerzl || ClientIdentifier.IsGmfUMR || ClientIdentifier.IsCsssiugs || ClientIdentifier.isCscp) {
                if (ClientIdentifier.fileNumberMatchSeriePrefix(patientModel.PatientResponse.Identifier01)) {
                    const index = patientModel.PatientResponse.Identifier01.indexOf("/");
                    identifier = index != -1
                        ? patientModel.PatientResponse.Identifier01.substring(0, index)
                        : patientModel.PatientResponse.Identifier01;
                }
            }

            // Use OtherIdentifier
            let bslIdentifier = patientModel.OtherPatientIdentifiers.firstOrDefault(x => x.Name == "Dossier Regional BSL");
            if (bslIdentifier != null)
                identifier = "BSL" + bslIdentifier.Number;
        }
        return identifier;
    }
}

export { PatientExternalIdentifier };
